import React from 'react';
import PropTypes from 'prop-types';
import DiscoverResult from './DiscoverResult';
import { getSortFilterNote } from '../../helpers/discover_helpers';
import './DiscoverResults.scss';

const DiscoverResults = ({ creators, sortBy, effectiveTotal, loadingMore, noMoreResults, lastCardRef, disambiguation, emptyMessage, getExplainer }) => {
  const firstUnscoredIdx = creators.findIndex(c => c.categoryAffinity == null);
  const filterNote = getSortFilterNote(sortBy);

  return (
    <div className='discover-results'>
      {effectiveTotal != null && (
        <div className='discover-progress'>
          Showing {creators.length.toLocaleString()} of {effectiveTotal.toLocaleString()} creators
        </div>
      )}
      {filterNote && <div className='discover-filter-note'>{filterNote}</div>}
      {creators.map((c, idx) => (
        <DiscoverResult
          key={c.id}
          creator={c}
          sortBy={sortBy}
          cardRef={idx === creators.length - 1 ? lastCardRef : null}
          showBoundary={sortBy === 'affinity' && idx === firstUnscoredIdx && idx > 0}
          disambiguation={disambiguation}
          explainer={getExplainer ? getExplainer(c.id) : undefined}
          proseEnabled={Boolean(getExplainer)}
        />
      ))}
      {loadingMore && <div className='discover-loading-more'>Loading more…</div>}
      {noMoreResults && creators.length > 0 && <div className='discover-end'>End of results</div>}
      {noMoreResults && creators.length === 0 && (
        <div className='discover-empty'>{emptyMessage || 'No creators match the current filters.'}</div>
      )}
    </div>
  );
};

DiscoverResults.propTypes = {
  creators: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortBy: PropTypes.string.isRequired,
  effectiveTotal: PropTypes.number,
  loadingMore: PropTypes.bool.isRequired,
  noMoreResults: PropTypes.bool.isRequired,
  lastCardRef: PropTypes.func.isRequired,
  disambiguation: PropTypes.object,
  emptyMessage: PropTypes.string,
  getExplainer: PropTypes.func,
};

export default DiscoverResults;
